import React from 'react';
import TableStadiumGroup from './TableStadiumGroup';


class Estadios extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      stadium_list: []
    };
  }

  componentDidMount(){

      this.getEquipos();

  }

   getEquipos(){
      fetch("https://www.registrosudec.com:5000/estadios_femenino")
     .then(res => res.json())
     .then(
       (result) => {
        result.push({'path':'todos', 'name':'Total', 'country':''});
        this.setState({stadium_list: result})
       },
       // Nota: es importante manejar errores aquí y no en
       // un bloque catch() para que no interceptemos errores
       // de errores reales en los componentes.
       (error) => {
         console.log(error);
         this.setState({stadium_list: []})
       }
     );
    }



  render(){

    return(
      <div>
      <div style={{ height: '100px' }}></div>
       <div>
           <TableStadiumGroup stadium_list={this.state.stadium_list}></TableStadiumGroup>
         </div>

      </div>
    )

}
}
export default Estadios;
